import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import WineDetail from "@/pages/WineDetail";
import Cart from "@/pages/Cart";
import Reservation from "@/pages/Reservation";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-[#F9F6F0] min-h-screen flex flex-col font-body text-[#1A1617]">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vins" element={<Catalog />} />
              <Route path="/vin/:id" element={<WineDetail />} />
              <Route path="/panier" element={<Cart />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <Toaster position="bottom-center" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
